import { Link } from "react-router-dom";
import { useLanguage, languageNames } from "./LanguageProvider";
import { LANGS } from "../seo/siteConfig";

export default function LanguageSwitcher() {
  const { language, localizedPath } = useLanguage();

  return (
    <div className="flex items-center gap-1" data-testid="language-switcher">
      {LANGS.map((l) => (
        <Link
          key={l}
          to={localizedPath(l)}
          hrefLang={l}
          lang={l}
          aria-current={l === language ? "true" : undefined}
          data-testid={`lang-switch-${l}`}
          className={`px-2 py-1 rounded text-xs font-bold transition-colors ${
            l === language
              ? "bg-[#4DD0E1] text-black"
              : "text-[#A1A1AA] hover:text-white"
          }`}
        >
          {languageNames[l].flag}
        </Link>
      ))}
    </div>
  );
}
